module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-security.925c1cc4.mp4";